type RouterFuture = {
  v7_startTransition: boolean;
  v7_relativeSplatPath: boolean;
};

export const routerFuture: RouterFuture = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};
